import PageLayout from "components/layouts/PageLayout";

import WebhookLogsTable from "./WebhookLogsTable";
import { useWebhookLogsFilter } from "./WebhookLogsTable/useWebhookLogsFilter";

const WebhookLogs = () => {
  const { filters, searchField } = useWebhookLogsFilter();

  return (
    <PageLayout
      title="Webhook Logs"
      subtitle="Track and debug webhook delivery logs."
      search={{
        value: searchField.value,
        onChange: searchField.onChange,
        placeholder: "Search logs by URL or body",
      }}
    >
      <WebhookLogsTable filters={filters} />
    </PageLayout>
  );
};

export default WebhookLogs;
